import { Stack } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

export const TenantConfigError = () => {
  const { t } = useTranslation();
  return (
    <Stack className="min-h-screen justify-center p-6 text-center">
      <div>
        <h1 className="font-ds-display-lg text-5xl">{t("general.unableToLoadApplicationTitle")}</h1>
        <p className="mt-4 text-3xl text-gray-500">{t("general.unableToLoadApplicationDescription")}</p>
      </div>
    </Stack>
  );
};
